import { render, staticRenderFns } from "./DocumentTransfer.vue?vue&type=template&id=26fa9548&scoped=true"
import script from "./DocumentTransfer.vue?vue&type=script&lang=js"
export * from "./DocumentTransfer.vue?vue&type=script&lang=js"
import style0 from "./DocumentTransfer.vue?vue&type=style&index=0&id=26fa9548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fa9548",
  null
  
)

export default component.exports